module.exports = __webpack_public_path__ + "static/ceo-42d302221c0024c42b349814c3976001.png";